/* global window */
/* global fetch */

import axios from 'axios';
import qs from 'qs';
import store from '../reducers/store';

import appConsts from '../constants/appConstants';

class PlayersService {
  constructor() {
    this.cancelTokens = [];
    this.page = 0;
    this._playersList = [];
  }

  getTrackedPlayers(playerList) {
    return axios({
      method: 'GET',
      url: process.env.API_URL + 'players/filters/?ids=' + playerList.join(','),
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
      // params,
      data: playerList,
      // cancelToken: this.cancelTokens[tokenLength - 1].token,
      paramsSerializer: (serializable) => {
        return qs.stringify(serializable, { encode: false });
      },
    })
      .then((response) => {
        const { data: playerData } = response.data;
        store.dispatch({ type: 'UPDATE_TRACKED_PLAYERS', trackedPlayers: playerData });
      })
      .catch((error) => {
        // throw JSON.parse(JSON.stringify(error)).response.data;
      });
  }

  getHiddenPlayers() {
    const data = {
      hidden: 'true',
      tracked: 'false',
      page: '1',
      sort: { sortBy: 'name', sortDirection: 'ASC' },
    };

    return axios({
      method: 'POST',
      url: process.env.API_URL + 'players/',
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
      // params,
      data,
      // cancelToken: this.cancelTokens[tokenLength - 1].token,
      paramsSerializer: (serializable) => {
        return qs.stringify(serializable, { encode: false });
      },
    })
      .then((response) => {
        const { data: playerData } = response.data;
        store.dispatch({ type: 'UPDATE_HIDDEN_PLAYERS', hiddenPlayers: playerData });
      })
      .catch((error) => {
        // console.warn('error in get many players');
        // console.warn(error);
        if (axios.isCancel(error)) {
          // console.log(error.message)
        }
        // throw JSON.parse(JSON.stringify(error)).response.data;
      });
  }

  getPlayers(name) {
    const startYear = appConsts.START_YEAR;

    const years = [];

    for (let i = startYear; i < startYear + 4; i++) {
      years.push(i);
    }

    const data = {
      // hidden: 'false',
      tracked: 'false',
      name: name,
      page: '1',
      sort: { sortBy: 'name', sortDirection: 'ASC' },
      years,
    };

    this.cancelTokens.push(axios.CancelToken.source());

    const tokenLength = this.cancelTokens.length;

    return axios({
      method: 'POST',
      url: process.env.API_URL + 'players/',
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
      data,
      cancelToken: this.cancelTokens[tokenLength - 1].token,
      paramsSerializer: (serializable) => {
        return qs.stringify(serializable, { encode: false });
      },
    })
      .then((response) => {
        const { data: playerData } = response.data;
        store.dispatch({ type: 'UPDATE_PLAYERS', players: playerData });
      })
      .catch((error) => {
        // console.warn('error in get many players');
        // console.warn(error);

        if (axios.isCancel(error)) {
          // console.log(error.message)
        }
        // throw JSON.parse(JSON.stringify(error)).response.data;
      });
  }

  cancelCall(message) {
    this.cancelTokens.forEach((token) => {
      token.cancel(message);
    });
  }
}

export default new PlayersService();



// WEBPACK FOOTER //
// ./src/services/playersService.js